// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__h7nlY","content":"LayoutSettings_content__1_UgL"};